import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'bootstrap/dist/css/bootstrap.min.css';
import DataTable from 'react-data-table-component';
import Header_Company from "../../Components/Header_Company";
import Header from '../../Components/Header_Admin';
import { CSVLink } from 'react-csv';
import { paybridge_Url, BASE_URL } from '../../Config';

const Company_Report = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [status, setStatus] = useState('All');
  const [mobileNo, setMobileNo] = useState('');
  const [authCode, setAuthCode] = useState('');
  const [agentId, setAgentId] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [userRole, setuserRole] = useState(false);
  const [companyDetails, setCompanyDetails] = useState([]);

  // ✅ ✅ TOOLTIP FUNCTION (FIX)
  const renderWithTooltip = (value) => {
    const text = value ?? '-';

    return (
      <div
        title={text}
        style={{
          maxWidth: '150px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {text}
      </div>
    );
  };

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    if (!user) {
      Swal.fire("Error", "User not logged in.", "error");
      return;
    }

    const userData = JSON.parse(user);
    setCompanyId(userData.companyId || '');
    setuserRole(userData.userRole || '');

    if (userData.userRole === "Admin") {
      const fetchCompany = async () => {
        setLoading(true);
        try {
          const response = await axios.get(`${BASE_URL}AllCompany?status=Active`);
          const res = response.data;

          if (Array.isArray(res.companyDetails)) {
            setCompanyDetails(res.companyDetails);
          } else {
            setCompanyDetails([]);
          }
        } catch (err) {
          setCompanyDetails([]);
          Swal.fire("Error", "Failed to fetch companies", "error");
        } finally {
          setLoading(false);
        }
      };

      fetchCompany();
    }
  }, []);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const requestBody = {};
      if (fromDate) requestBody.startDate = fromDate;
      if (toDate) requestBody.endDate = toDate;
      if (status !== "All") requestBody.status = status;
      if (companyId) requestBody.companyId = companyId;
      if (agentId) requestBody.agentId = agentId;
      if (mobileNo) requestBody.mobileNo = mobileNo;
      if (authCode) requestBody.authCode = authCode;

      const response = await axios.post(`${paybridge_Url}report/payments`, requestBody);

      if (response.data.success) {
        setReportData(response.data.data || []);
      } else {
        Swal.fire("Info", "No data found", "info");
        setReportData([]);
      }
    } catch (error) {
      Swal.fire("Error", "Error fetching report", "error");
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Columns with tooltip
  const columns = [
    { name: 'Transaction Ref', selector: row => renderWithTooltip(row.txn_ref_no), sortable: true },
    { name: 'Bill Reference', selector: row => renderWithTooltip(row.bill_reference), sortable: true },
    { name: 'Amount', selector: row => renderWithTooltip(`PKR ${row.amount}`), sortable: true },
    { name: 'Mobile No', selector: row => renderWithTooltip(row.mobile_no ?? row.pp_MobileNumber), sortable: true },
    { name: 'Status', selector: row => renderWithTooltip(row.status), sortable: true },
    { name: 'Customer Name', selector: row => renderWithTooltip(row.CustomerName), sortable: true },
    { name: 'Agent Name', selector: row => renderWithTooltip(row.agent_Name), sortable: true },
    { name: 'Company Name', selector: row => renderWithTooltip(row.company_Name), sortable: true },
    {
      name: 'Created At',
      selector: row => renderWithTooltip(
        row.created_at ? new Date(row.created_at).toLocaleString() : '-'
      ),
      sortable: true
    },
    { name: 'Response Code', selector: row => renderWithTooltip(row.pp_ResponseCode), sortable: true },
    { name: 'Response Message', selector: row => renderWithTooltip(row.Static_Response), sortable: true }
  ];

  const prepareCsvData = () => reportData.map(row => ({
    'Transaction Ref': row.txn_ref_no ?? '-',
    'Bill Reference': row.bill_reference ?? '-',
    'Amount': row.amount ?? '-',
    'Mobile No': row.mobile_no ?? '-',
    'Status': row.status ?? '-',
    'Customer Name': row.CustomerName ?? '-',
    'Agent Name': row.agent_Name ?? '-',
    'Company Name': row.company_Name ?? '-',
    'Created At': row.created_at ?? '-',
    'Response': row.Static_Response ?? '-',
    'Responsecode': row.pp_ResponseCode ?? '-'

  }));

  return (
    <div className="container">
      
      {userRole === "Company" ? <Header_Company /> : <Header />}

      <div className="card mt-2">

        <div className="card-header text-center">
          <h2>Company Sales Report</h2>
        </div>

        <div className="card-body">
          <div className="row mb-2">

            <div className="col-md-2">
              <label>From Date</label>
              <input type="date" className="form-control" onChange={e => setFromDate(e.target.value)} />
            </div>

            <div className="col-md-2">
              <label>To Date</label>
              <input type="date" className="form-control" onChange={e => setToDate(e.target.value)} />
            </div>

            <div className="col-md-2">
              <label>Status</label>
              <select className="form-control" onChange={e => setStatus(e.target.value)}>
                <option>All</option>
                <option>COMPLETED</option>
                <option>PENDING</option>
                <option>FAILED</option>
              </select>
            </div>

            <div className="col-md-2">
              <label>Mobile No</label>
              <input type="text" className="form-control" onChange={e => setMobileNo(e.target.value)} />
            </div>

            <div className="col-md-2">
              <label>TID</label>
              <input type="text" className="form-control" onChange={e => setAuthCode(e.target.value)} />
            </div>

            {userRole === "Admin" && (
              <div className="col-md-2">
                <label>Company</label>
                <select className="form-control" onChange={e => setCompanyId(e.target.value)}>
                  <option value="">Select Company</option>
                  {companyDetails.map(c => (
                    <option key={c.applicationUserId} value={c.applicationUserId}>
                      {c.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="col-md-2 mt-2">
              <button className="btn btn-primary w-100" onClick={fetchReport}>
                Fetch Report
              </button>
            </div>

          </div>

          <DataTable
            columns={columns}
            data={reportData}
            pagination
            highlightOnHover
            responsive
          />

          <CSVLink data={prepareCsvData()} filename="company_payments_report.csv" className="btn btn-success mt-3">
            Download CSV
          </CSVLink>

        </div>
      </div>
    </div>
  );
};

export default Company_Report;